{
  "VALIDATION_FAILED": "البيانات المرسلة غير صالحة",
  "PHONE_TAKEN": "رقم الهاتف مسجل لعميل آخر",
  "DOCUMENT_TAKEN": "الوثيقة مسجلة لعميل آخر",
  "CATEGORY_IN_USE": "هذا التصنيف مرتبط بعملاء ولا يمكن حذفه",
  "USERNAME_TAKEN": "اسم المستخدم هذا مستخدم بالفعل",
  "NO_PLATFORM_ACCESS": "ليس لديك صلاحية الوصول إلى هذا النظام",
  "UA_UNAVAILABLE": "تعذر الوصول إلى الدخول الموحد. أعد المحاولة بعد قليل.",
  "INTEGRATION_UNAUTHORIZED": "بيانات اعتماد التكامل غير صالحة",
  "UNAUTHENTICATED": "يجب تسجيل الدخول",
  "INVALID_CREDENTIALS": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  "FORBIDDEN": "ليس لديك صلاحية لتنفيذ هذا الإجراء",
  "NOT_FOUND": "العنصر المطلوب غير موجود",
  "CONFLICT": "تعارض في البيانات. أعد تحميل البيانات الحالية.",
  "UNIQUE_VIOLATION": "هذه القيمة مستخدمة بالفعل",
  "FOREIGN_KEY_VIOLATION": "هذا العنصر مرتبط بعناصر أخرى ولا يمكن حذفه",
  "RATE_LIMITED": "عدد كبير جدا من المحاولات. أعد المحاولة بعد قليل.",
  "IDEMPOTENCY_KEY_REUSED": "تم استخدام رقم هذا الطلب لعملية أخرى مسبقا",
  "MOVEMENT_REFERENCE_CONFLICT": "الرقم المرجعي للحركة مستخدم مسبقا لبيانات حركة مختلفة",
  "REQUEST_IN_PROGRESS": "لا يزال هذا الطلب قيد المعالجة",
  "PAYLOAD_TOO_LARGE": "البيانات المرسلة تتجاوز الحجم المسموح به",
  "UNPROCESSABLE": "تعذرت معالجة الطلب. تحقق من البيانات المرسلة.",
  "INTERNAL_ERROR": "تعذر إكمال العملية. أعد المحاولة أو تواصل مع المسؤول.",
  "SERVICE_UNAVAILABLE": "الخدمة غير متاحة حاليا. أعد المحاولة بعد قليل.",
  "network": "تعذر الاتصال بالخادم. تحقق من اتصالك وأعد المحاولة.",
  "timeout": "لم نتمكن من تأكيد اكتمال العملية. تحقق من الحالة الحالية قبل إعادة المحاولة.",
  "PHONE_REQUIRED": "رقم الهاتف مطلوب",
  "PHONE_INVALID": "رقم الهاتف غير صالح",
  "PHONE_NOT_MOBILE": "رقم أرضي غير مسموح، أدخل رقم خلوي",
  "PHONE_COUNTRY_NOT_ALLOWED": "أرقام هذه الدولة غير مقبولة",
  "PHONE_VERIFICATION_REQUIRED": "يجب تأكيد رقم الهاتف قبل الحفظ",
  "PHONE_VERIFICATION_INVALID": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_INVALID": "الرمز غير صحيح",
  "OTP_EXPIRED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_ATTEMPTS_EXCEEDED": "تم تجاوز عدد المحاولات، اطلب رمزا جديدا",
  "OTP_RESEND_TOO_SOON": "إعادة إرسال الرمز غير متاحة الآن",
  "OTP_SEND_LIMIT": "تم إرسال عدد كبير من الرموز لهذا الرقم",
  "OTP_SEND_FAILED": "تعذر إرسال رمز التحقق عبر واتساب ولم يتم الحفظ. حاول مجددا، أو يمكن للمسؤول إيقاف تأكيد الرقم من الإعدادات",
  "OTP_ALREADY_VERIFIED": "تم تأكيد رقم الهاتف",
  "OTP_ALREADY_CONSUMED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_BINDING_MISMATCH": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_NOT_VERIFIED": "يجب تأكيد رقم الهاتف قبل الحفظ",
  "OTP_CONSUME_WINDOW_PASSED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "IDEMPOTENCY_CONFLICT": "تم استخدام رقم هذا الطلب لعملية أخرى مسبقا",
  "PHONE_VERIFICATION_RECEIPT_EXPIRED": "انتهت صلاحية تأكيد الرقم، أعد التحقق"
}
